import PropTypes from "prop-types";
import { FinderField } from "../../../../components/finder-field";
import { useVerificationDetails } from "../../../../context/verification-details";
import { setOrganisation } from "../../../../state/verification-details/reducer";
import { fetchSchoolList } from "../../../../utilities/fetch-school-list";
import styles from "./styles";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../../context/locale-provider";
import { useState } from "react";

export const SchoolFinderField = ({
  organisation,
  validationErrors,
  setValidationErrors,
  onChange,
  sheerIdProgramId,
  orgSearchUrl,
  sheerIdLocale,
}) => {
  const translate = useTranslate(useLocaleProvider());

  const [state, dispatch] = useVerificationDetails();
  const { countryCode } = state.verificationDetails;
  const [isOffline, setIsOffline] = useState(false);

  const getSchoolOptions = async () => {
    const response = await fetchSchoolList(
      orgSearchUrl,
      countryCode,
      organisation.name
    );
    if (response?.networkError) {
      setValidationErrors({ ...validationErrors, organisation: true });
      setIsOffline(true);
    }
    return response;
  };

  return (
    <FinderField
      className={styles.wrapper}
      label={`${translate("sv_form_school_label")}:`}
      ariaLabel={translate("sv_form_school_label")}
      sheerIdProgramId={sheerIdProgramId}
      sheerIdLocale={sheerIdLocale}
      fetchOptions={getSchoolOptions}
      textFieldId="organisation"
      textFieldHasError={validationErrors.organisation}
      textFieldErrorMessage={
        isOffline
          ? translate("sv_internet_connection_error")
          : translate("sv_form_school_error")
      }
      textFieldOnChange={onChange}
      resultsListId="organisations"
      resultsListOnChange={(school) => dispatch(setOrganisation(school))}
      resultsItemId="organisation"
      value={organisation}
      required
    />
  );
};

SchoolFinderField.propTypes = {
  onChange: PropTypes.func.isRequired,
  setValidationErrors: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  orgSearchUrl: PropTypes.string.isRequired,
  sheerIdProgramId: PropTypes.string.isRequired,
  sheerIdLocale: PropTypes.string.isRequired,
};

SchoolFinderField.defaultProps = {
  organisation: {
    name: "",
    id: "",
  },
};
